export default "__VITE_ASSET__3ed9e819__"